module.exports = __webpack_public_path__ + "images/jobs/devWebMissions.753a41f8.jpg";